import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import moment from "moment";
import { connect } from "react-redux";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import SuccessModal from "./components/SuccessModal";
import IconStoreModal from "./components/IconStoreModal";
import schedule_icon from "../../assets/media/token_earning/wall-clock.png";
import shortid from "shortid";
import "./index.css";
import CurrentResultModal from "./components/CurrentResultModal";
import NewPoll from "../../components/NewPoll";
import EditPollModal from "./components/EditPollModal";
import MediaContentViewer from "../../components/MediaContentViewer";
import { idealTextColor } from "../../functions";
const icon_pending_img = require("../../assets/media/icons/pending.png");

function Polls({ myRole, dispatch }) {
  const history = useHistory();
  const location = useLocation();
  const { brand, role, username } = location.state;
  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState(0);
  const [answerIndex, setAnswerIndex] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [brandData, setBrandData] = useState({
    logo: null,
    icon: null,
    brand_name: "",
    brand_url: "",
    hex: null,
    white: null,
    umbrellaBrand: null,
    poll_data: [],
    users: [],
    is_property_brand: false,
    is_supportchat_needed: false,
    is_programmetool_need: false,
  });
  const [pollToEdit, setPollToEdit] = useState();

  useEffect(() => {
    if (!location.state) {
      history.push("/");
    } else {
      const getBrandData = async () => {
        Firebase.getBrandDataByID(brand, async (brand_data) => {
          let users = [];
          try {
            users = await Firebase.getAllUsersInBrand(brand_data.name);
          } catch (err) {
            users = [];
          }
          const { parent } = brand_data;
          let pollData = brand_data.polls || [];
          pollData.sort((a, b) => b.created_at - a.created_at);
          if (parent) {
            // I am inside sub brand and wanna get parent poll data
            Firebase.getBrandDataByID(parent, (parentBrand_Data) => {
              const parentPoll = (parentBrand_Data.polls || []).filter(
                (i) => i.postToSub
              );
              pollData = [...parentPoll, ...pollData];
            });
          }
          setBrandData({
            logo: brand_data.logo,
            icon: brand_data.icon,
            brand_name: brand_data.name,
            brand_url: brand_data.url,
            hex: brand_data.hex,
            white: brand_data.white,
            umbrellaBrand: brand_data.umbrella,
            poll_data: pollData,
            users,
            is_property_brand: brand_data.is_property_brand
              ? brand_data.is_property_brand
              : false,
            is_supportchat_needed: brand_data.is_supportchat_needed
              ? brand_data.is_supportchat_needed
              : false,
            is_programmetool_need: brand_data.is_programmetool_need
              ? brand_data.is_programmetool_need
              : false,
          });
          setLoading(false);
        });
      };
      setLoading(true);
      getBrandData();
    }
  }, []);

  const selectImage = (url) => {
    const newAnswers = answers;
    newAnswers[answerIndex].icon = url;
    setAnswers(newAnswers);
  };

  const post = async (data) => {
    const {
      answers,
      question,
      media_type,
      media_url,
      // quiz_img,
      hot_topic,
      postNow,
      toMembers = false,
      toReferals = false,
      scheduledDate,
    } = data;
    if (postNow) {
      // poll submit immediately with close all polls
      // Only one open poll can exists
      if (brandData.poll_data.find((item) => !item.closed)) {
        const polls = [...brandData.poll_data];
        polls.forEach((obj) => (obj.closed = true));
        Firebase.updateBrandDataById(brand, { polls });
      }
    }

    // let question_img = await Firebase.uploadImage(
    //   quiz_img,
    //   brandData.brand_name,
    //   "polls"
    // );
    const poll = {
      id: shortid.generate(),
      answers,
      question,
      // question_img,
      media_type,
      media_url,
      hot_topic,
      created_at: moment().valueOf(),
      postNow,
      toMembers,
      toReferals,
      scheduledDate: postNow ? moment().valueOf() : scheduledDate.valueOf(),
    };
    if (myRole === "isUmbrella" && brandData.umbrellaBrand)
      poll.postToSub = true;
    Firebase.updateBrandDataById(brand, {
      polls: [...brandData.poll_data, poll],
    });
    document.getElementById("success_btn").click();

    if (!postNow) {
      let schedule_data = {
        id: poll.id,
        type: "poll",
        time: poll.scheduledDate,
        brand_name: brandData.brand_name,
        brand_id: brand,
      };
      let schedule_res = await Firebase.registerSchedule(schedule_data);
      console.log("schedule_res", schedule_res);
    }
  };

  const updatePoll = (pollToUpdate) => {
    const polls = [...brandData.poll_data];
    const indexToUpdate = polls.findIndex((p) => p.id === pollToUpdate.id);
    polls[indexToUpdate] = pollToUpdate;
    Firebase.updateBrandDataById(brand, {
      polls: polls,
    });
  };

  const onClosePoll = (index) => () => {
    const polls = [...brandData.poll_data];
    polls[index].closed = true;
    const uid = localStorage.getItem("uid");
    Firebase.updateBrandDataById(brand, { polls });
    const { brand_name = "Ecosystem" } = brandData;
    Firebase.getAllUsersInBrand(brand_name).then((users) => {
      if (!users || !users.length) {
        return;
      }

      const message = polls[index].question.toLowerCase().replace("?", "");

      users.forEach((user) => {
        if (!user.poll_answers) return;
        if (
          user.poll_answers.every(
            (answer) => answer.poll_id !== polls[index].id
          )
        )
          return;
        const data = {
          time: Date.now(),
          latest: `The poll for ${message}, has closed.`,
          sender_name: username,
          sender_id: uid,
        };

        Firebase.addUnreadMessage(brand_name, user.id, uid, data);
      });
    });
  };

  const getNumberOfVotes = (poll) => {
    if (
      poll.isDemo &&
      poll.question ===
        "Demo Poll - Where would you like to go on Holiday to next?"
    ) {
      return 38;
    }

    return brandData.users.filter(
      (user) =>
        !!(user.poll_answers || []).find((answer) => answer.poll_id === poll.id)
    ).length;
  };

  const getAnswersChat = (poll) => {
    if (
      poll.isDemo &&
      poll.question ===
        "Demo Poll - Where would you like to go on Holiday to next?"
    ) {
      const answers = [...poll.answers];
      answers[0].count = 22;
      answers[1].count = 2;
      answers[2].count = 4;
      answers[3].count = 10;
      return answers;
    }
    const answers = poll.answers.map((answer) => ({
      ...answer,
      count: 0,
    }));
    const filteredUsers = brandData.users.filter(
      (user) =>
        !!(user.poll_answers || []).find((answer) => answer.poll_id === poll.id)
    );

    filteredUsers.forEach((user) => {
      const answer = (user.poll_answers || []).find(
        (answer) => answer.poll_id === poll.id
      );
      if (answer) {
        answers[answer.answer_id].count += 1;
      }
    });

    // console.log('/// -- answers', answers);

    return answers;
  };
  const getStatusText = (poll) => {
    if (poll.closed) {
      return "Closed";
    } else {
      if (poll.postNow) {
        return "Live";
      } else return "Pending";
    }
  };
  const renderClosedPolls = () => {
    console.log("poll_data", brandData.poll_data);
    return (
      <div className="poll-items">
        {brandData.poll_data.map((poll, index) => (
          <div className="poll-item-container" key={index}>
            <div style={{ width: "300px", height: "200px" }}>
              <MediaContentViewer
                media_type={poll.media_type}
                media_url={poll.media_url}
              />
            </div>
            <div className="poll-details">
              <p className="submitted-date">
                {poll.postNow === false ? (
                  <p>
                    <img
                      alt=""
                      src={schedule_icon}
                      width="20"
                      height="20"
                      style={{ marginRight: 10 }}
                    />
                    Poll scheduled on {moment(poll.scheduledDate).format("LLL")}
                  </p>
                ) : (
                  "Poll submitted on " + moment(poll.created_at).format("LLL")
                )}
              </p>
              <p className={`status-txt ${getStatusText(poll)}`}>
                {getStatusText(poll)}
              </p>
              <p className="question">{poll.question}</p>
              <p className="vote">{getNumberOfVotes(poll)} member votes</p>
            </div>
            <div className="btn-container">
              <div
                className="poll-toggle-btn"
                data-toggle="modal"
                data-target={`#poll_result_modal_${poll.id}`}
                style={{
                  "--hover-color": brandData.hex ? brandData.hex : "white",
                  "--hover-text-color": brandData.white ? "white" : "black",
                  pointerEvents: getNumberOfVotes(poll) === 0 ? "none" : "auto",
                }}
              >
                View poll results
              </div>
              <div
                className="poll-toggle-btn"
                data-toggle="modal"
                data-target={`#poll_edit_modal`}
                onClick={() => {
                  setPollToEdit(poll);
                }}
                style={{
                  "--hover-color": brandData.hex ? brandData.hex : "white",
                  "--hover-text-color": brandData.white ? "white" : "black",
                }}
              >
                Edit the poll
              </div>
              {!poll.closed && (
                <div
                  className="poll-toggle-btn"
                  onClick={onClosePoll(index)}
                  style={{
                    "--hover-color": brandData.hex ? brandData.hex : "white",
                    "--hover-text-color": brandData.white ? "white" : "black",
                  }}
                >
                  Close the Poll
                </div>
              )}
            </div>
            <CurrentResultModal
              id={poll.id}
              answers={getAnswersChat(poll)}
              question={poll.question}
            />
          </div>
        ))}
        <EditPollModal
          poll={pollToEdit}
          brand_name={brandData.brand_name}
          updatePoll={updatePoll}
        />
      </div>
    );
  };

  return (
    <div id="page-container">
      <Header
        username={username}
        role={role}
        onHome={history.goBack}
        logo={brandData.logo}
        brand={brand}
        brandName={brandData.brand_name}
        is_property_brand={brandData.is_property_brand}
      />
      <div id="polls-container">
        {loading && (
          <div className="polls-loading-bar">
            <i className="fa fa-4x fa-sync fa-spin text-muted" />
          </div>
        )}
        {!loading && (
          <React.Fragment>
            <div className="toggle-btn-group">
              <div
                className="mode-toggle-btn"
                onClick={() => setTab(0)}
                style={{
                  backgroundColor: tab === 0 ? brandData.hex : "white",
                  color:
                    tab === 0 ? (brandData.white ? "white" : "black") : "black",
                }}
              >
                New Poll Listing
              </div>
              <div
                className="mode-toggle-btn"
                onClick={() => setTab(1)}
                style={{
                  backgroundColor: tab === 1 ? brandData.hex : "white",
                  color:
                    tab === 1 ? (brandData.white ? "white" : "black") : "black",
                }}
              >
                Listed & Scheduled Polls
              </div>
            </div>
            {tab === 0 && (
              <NewPoll onAdd={post} brand_name={brandData.brand_name} />
            )}
            {tab === 1 && renderClosedPolls()}
          </React.Fragment>
        )}
      </div>
      <button
        id="success_btn"
        type="button"
        data-toggle="modal"
        data-target="#success"
        style={{ display: "none" }}
      />
      <IconStoreModal selectImage={selectImage} />
      <SuccessModal />
    </div>
  );
}
// function mapDispatchToProps(dispatch) {
//   return {
//     dispatch,
//   };
// }
function mapStateToProps(state) {
  return {
    myRole: state.myRole,
  };
}
export default connect(mapStateToProps)(Polls);



// WEBPACK FOOTER //
// ./src/screens/Polls/index.js